module.exports = __webpack_public_path__ + "img/01.f25a61a2.jpg";